import { render, staticRenderFns } from "./FaqSelectTrainTopicsDialog.vue?vue&type=template&id=81b7f9c8&scoped=true&"
import script from "./FaqSelectTrainTopicsDialog.vue?vue&type=script&lang=js&"
export * from "./FaqSelectTrainTopicsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b7f9c8",
  null
  
)

export default component.exports